var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46346 5.65222C6.59756 5.65222 6.73029 5.62525 6.85376 5.57291L18.6097 0.58937C19.2691 0.309831 20 0.793837 20 1.51006V18.4899C20 19.2062 19.2691 19.6902 18.6097 19.4106L8.05696 14.9371C7.39754 14.6576 6.66667 15.1416 6.66667 15.8578V19C6.66667 19.5523 6.21895 20 5.66667 20H3.22222C2.66994 20 2.22222 19.5523 2.22222 19V15.3478C2.22222 14.7955 1.75292 14.3668 1.25561 14.1265C1.03345 14.0192 0.828651 13.8747 0.650874 13.6969C0.234126 13.2802 0 12.7149 0 12.1256V7.87444C0 7.28507 0.234126 6.71984 0.650874 6.3031C1.06762 5.88635 1.63285 5.65222 2.22222 5.65222H6.46346Z",
    fill: "#7266BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityPurple);
export default __webpack_public_path__ + "static/media/communityPurple.9798174c49ea74b09279121f63ac77e9.svg";
export { ForwardRef as ReactComponent };